<script setup>
defineProps({
    status: {
        required: true,
        type: String,
    }
});

const statusText = {
    draft: 'Draft',
    pending: 'In Review',
    active: 'Active',
    sold: 'Sold',
    rejected: 'Rejected',
};

const statusColor = {
    draft: 'black',
    pending: 'warning',
    active: 'primary',
    sold: 'info',
    rejected: 'danger',
};
</script>

<template>
    <app-status-badge :text="statusText[status]" :color="statusColor[status]" />
</template>
